<div *ngIf="members" class="row bg-white">
  <div class="col-sm-12">
    <table class="table">
      <caption class="sr-only">Tabella membri</caption>
      <thead>
        <tr>
          <th class="col-xs-3">Nominativo</th>
          <th class="col-xs-3">Ruolo</th>
          <th class="col-xs-3">Data associazione</th>
          <th class="col-xs-3">Data fine rapporto</th>
          <th class="col-xs-3"></th>
        </tr>
      </thead>
      <tbody>
        <tr class="{{!member.validTo ? 'bg-white' : 'bg-light'}}" *ngFor="let member of members.items">
          <td *ngIf="member.person.type === 'PHYSICAL_ENTITY'" class="col-xs-3 cell"><span class="glyphicon ml-0 glyphicon-user span-icon mr-10"></span>{{member.person.lastName}}
            {{member.person.firstName}} </td>
          <td *ngIf="member.person.type === 'LEGAL_ENTITY'" class="col-xs-3 cell"><span class="glyphicon ml-0 glyphicon-briefcase span-icon mr-10"></span>{{member.person.name}}</td>
          <td class="col-xs-3 cell">{{member.role.description}}</td>
          <td class="col-xs-3 cell">
            <p class="ml-20">{{member.validFrom | date: 'dd/MM/yyyy'}}</p>
          </td>
          <td class="col-xs-3 cell">
            <p class="ml-20">{{member.validTo | date: 'dd/MM/yyyy'}}</p>
          </td>
          <td class="rightaligned">

            <div *ngIf="!member.validTo" class="data_opzioni classificazione">
              <ul>
                <li class="opzioni" appDropdownFocus>
                  <a class="dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
                    aria-expanded="false">Opzioni<span class="glyphicon glyphicon-option-vertical"></span></a>
                  <div class="dropdown-menu dropdown-table">
                    <ul>
                      <li><span class="glyphicon ml-0 glyphicon-pencil span-icon"></span><a href="javascript:void(0)"
                          (click)="onEdit(member)">Modifica</a></li>
                      <li><span class="glyphicon ml-0 glyphicon-trash span-icon"></span><a href="javascript:void(0)"
                          (click)="onDelete(member)">Elimina</a></li>
                      <li><span class="glyphicon ml-0 glyphicon-off span-icon"></span><a href="javascript:void(0)"
                          (click)="onFinish(member)">Concludi rapporto</a></li>
                      <li><span class="glyphicon ml-0 glyphicon glyphicon-retweet span-icon"></span><a href="javascript:void(0)"
                          (click)="onTransfer(member)">Trasferisci membro</a></li>

                    </ul>
                  </div>
                </li>
              </ul>
            </div>

          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="members" class="col-sm-12">
    <div class="card-pagination">
      <app-pagination
        [totalItems]="members.totalItems"
        [hasAutoRefresh]="true"
        [resetCurrentPage]="resetCurrentPage"
        (refreshEvent)="refreshEvent.emit($event)">
      </app-pagination>
    </div>

  </div>

</div>
